<template>
  <div class="formWrapper">
    <el-form :model="form" ref="form" :rules="rules" :label-width="'120px'">
      <el-form-item label=" " v-if="!disabled">
        <el-radio-group v-model="form.dhcp" :disabled="disabled">
          <el-radio :label="true">自动</el-radio>
          <el-radio :label="false">手动</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="ip地址" :rules="rules.days" prop="ip">
        <Keyboard
          v-model="form.ip"
          :ip="true"
          :disabled="form.dhcp || disabled"
        >
          <el-input v-model="form.ip" :disabled="form.dhcp || disabled"
        /></Keyboard>
      </el-form-item>
      <el-form-item label="子网掩码" :rules="rules.days" prop="mask">
        <Keyboard
          v-model="form.mask"
          :ip="true"
          :disabled="form.dhcp || disabled"
        >
          <el-input v-model="form.mask" :disabled="form.dhcp || disabled"
        /></Keyboard>
      </el-form-item>
      <el-form-item label="网关" :rules="rules.days" prop="gateway">
        <Keyboard
          v-model="form.gateway"
          :ip="true"
          :disabled="form.dhcp || disabled"
        >
          <el-input v-model="form.gateway" :disabled="form.dhcp || disabled"
        /></Keyboard>
      </el-form-item>
      <el-form-item label="网络状态" style="color: #fff">
        {{ form.status }}
      </el-form-item>
    </el-form>
    <div class="subBox" v-if="!disabled">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import Keyboard from "@/components/keyboard/index.vue";
import { ElNotification, ElMessageBox } from "element-plus";

export default {
  name: "Page",
  components: { Keyboard },
  data() {
    return {
      rules: {
        days: [
          {
            required: true,
            message: "必填",
          },
        ],
      },
      form: [],
      disabled: false,
    };
  },
  methods: {
    async submit() {
      try {
        // console.log(v.$refs.form.validate);
        let valRes = await this.$refs.form.validate();
        console.log(valRes);
      } catch (err) {
        console.log("err autoForm1");
        console.log(err);
        return;
      }
      // return;
      try {
        let res = await this.$myRequest({
          url: "/post-network-settings",
          method: "post",
          data: this.form,
        });
        ElNotification({
          title: "提示",
          message: "操作成功",
          type: "success",
        });

        const result = await ElMessageBox.confirm(
          "重启系统配置才能生效，是否现在重启系统？",
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        if (result === "confirm") {
          this.$myRequest({
            url: "/post-system-restart",
            method: "post",
          });
        }

        this.init();
      } catch (err) {
        console.log("save err");
        console.log(err);
      }
    },
    async init() {
      // debugger;
      try {
        let res;
        res = await this.$myRequest({
          url: "/list-network-settings",
          method: "get",
          data: {},
        });
        console.log("res  init");
        console.log(res);
        this.form = res.data.data;
      } catch (err) {
        console.log("err  init");
        console.log(err);
      }
    },
  },
  mounted() {
    // console.log(this.$route.path.split("/")[3]);
    this.init();
    if (this.$route.name == "userSetSystemHome") {
      this.disabled = true;
    }
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
